import { render, staticRenderFns } from "./myEventsList.vue?vue&type=template&id=45de07dc&scoped=true"
import script from "./myEventsList.vue?vue&type=script&lang=js"
export * from "./myEventsList.vue?vue&type=script&lang=js"
import style0 from "./myEventsList.vue?vue&type=style&index=0&id=45de07dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de07dc",
  null
  
)

export default component.exports